/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input } from '@angular/core';
import { WFMComponent } from '@core/lib/components/wfm.component';

@Component({
  selector: 'wfm-patient-banner',
  templateUrl: './patient-banner.component.html',
  styleUrls: ['./patient-banner.component.scss']
})
export class PatientBannerComponent implements AfterViewInit {
  /**
   * @description items array. Each item must have the following property:
   * ```javascript
   *  {
   *    "label": "Patient",
   *    "data": [{
   *             "key": "value"}]
   * }
   * ```
   * `label` property is mandatory to display in dropdown and `data` is mandatory to populate the data
   */
  @Input() patientsList: any[];
  @Input() patient: any;
  @Input() placeholder = 'Select a patient';
  @Input() type = 'default';
  @Input() isCompressed = false;
  @Input() isDarkTheme = false;
  @Input() isCollapsible = false;
  @Input() isColumns = false;
  @Input() isStacked = false;
  @Input() isTabsMode = false;
  @Input() isIconHidden = false;
  @Input() isDropdownHidden = false;

  isPatientSelected = false;
  isCollapsed = false;

  constructor(private readonly element: ElementRef, private readonly cd: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (this.isDropdownHidden && !this.patient) {
      this.patient = this.patientsList && this.patientsList.length > 0 && this.patientsList[0];
    }
  }

  public responsiveBehaviorsDebounce = WFMComponent.debounce(() => {
    if (this.patient && this.isCollapsible && this.isCollapsed === true) {
      this.collapseData(true);
    }
  }, 500);

  @HostListener('window:resize')
  onResize() {
    this.responsiveBehaviorsDebounce();
  }

  onItemSelected(event) {
    this.patient = event;

    if (this.isCollapsible) {
      this.collapseData();
    }

    if (event) {
      this.isPatientSelected = true;
    }
  }

  onIconClick() {
    if (this.isCollapsed) {
      this.expandData();
    } else {
      this.collapseData();
    }
  }

  returnZero() {
    return 0;
  }

  expandData() {
    this.isCollapsed = false;
    this.cd.detectChanges();
    const data = this.element.nativeElement.querySelectorAll('.patient-banner__data');
    for (let i = 0; i < data.length; i++) {
      data[i].setAttribute('aria-hidden', 'false');
    }
    this.cd.detectChanges();
  }

  collapseData(resize?) {
    this.isCollapsed = true;
    if (!resize) {
    }
    // Added setTimeout due to changes not being detected immediately
    setTimeout(() => {
      this.cd.detectChanges();
    });
    this.cd.detectChanges();
    let currentElement,
      previousElement,
      hideElements = false;
    const data = this.element.nativeElement.querySelectorAll('.patient-banner__data');
    for (let i = 0; i < data.length; i++) {
      if (resize) {
        data[i].setAttribute('aria-hidden', 'false');
      }
      currentElement = data[i].getBoundingClientRect();
      if ((previousElement && previousElement.top < currentElement.top) || hideElements) {
        hideElements = true;
        data[i].setAttribute('aria-hidden', 'true');
      }
      previousElement = currentElement;
    }
  }
}
